export default __webpack_public_path__ + "static/iconography-image-h-7a4354f20893768d35a6754d39ed2f02.png";